module.exports = __webpack_public_path__ + "img/AR.06b9978a.png";